export const FETCH_PROVINCE_URL = `${process.env.REACT_APP_API_URL}/provinces`;
export const CREATE_PROVINCE_URL = `${process.env.REACT_APP_API_URL}/provinces/create`;
export const UPDATE_PROVINCE_URL = `${process.env.REACT_APP_API_URL}/provinces`;
export const DELETE_PROVINCE_URL = `${process.env.REACT_APP_API_URL}/provinces`;
